import { getYear } from 'date-fns';

import Button from '../../Button';
import DropdownMenu from '../../DropdownMenu';

const DEFAULT_YEAR = 2015;
const years = Array.from(
  Array(Math.abs(getYear(new Date()) + 0 - DEFAULT_YEAR) + 1),
  (_, i) => DEFAULT_YEAR + i
);

interface DatePickerYearsProps {
  selectedYear: number;
  setSelectedYear: (year: number) => void;
}

const DatePickerYears = ({
  selectedYear,
  setSelectedYear,
}: DatePickerYearsProps) => {
  return (
    <DropdownMenu>
      <DropdownMenu.Trigger asChild>
        <Button size='condensed' variant='outlined' color='secondary'>
          {selectedYear}
        </Button>
      </DropdownMenu.Trigger>
      <DropdownMenu.Content align='start' portal={false}>
        {years.map((year) => (
          <DropdownMenu.Item key={year} onClick={() => setSelectedYear(year)}>
            {year}
          </DropdownMenu.Item>
        ))}
      </DropdownMenu.Content>
    </DropdownMenu>
  );
};

export default DatePickerYears;
